module.exports = __webpack_public_path__ + "static/media/icon_info.609b60ec.svg";